<template>
    <div :class="(this.run.startNumber % 2 == 0 ? 'red':'blue')+' '+colorModifier+' pa-3'" v-if="this.run">
        <span class="display-1 mr-5">#{{ this.run.startNumber }} {{ this.run.application.title }}</span>
        <span class="headline">{{ this.run.application.assignedCategory.name }}</span>
        <div v-if="this.run.startNumber % 2 == 0  ? this.red : !this.red">
          <v-chip v-for="c in this.run.application.applicationCompetitors" :key="c.id" class="ma-1">
            <flag :iso="c.competitor.country" />
            &nbsp; {{c.competitor.firstName}} {{c.competitor.lastName}}
          </v-chip>
          <div class='d-flex justify-space-around mb-4 mt-2'>
              <v-btn fab color="error" v-on:click="clearTime" v-if="isDirty"><v-icon>mdi-restore</v-icon></v-btn>
              <span class='display-2 font-weight-black'>{{ this.timerFormatted }}</span>
              <v-btn fab color="success" class='float-right' v-if="isDirty" @click="save"><v-icon>save</v-icon></v-btn>
          </div>
          <div class="d-flex justify-space-around mb-4 mt-2" v-if="this.run.preliminaryTime != null && !isDirty">
              <v-btn text class="yellow" v-on:click="usePreliminary()">
                <v-icon>mdi-timer</v-icon>
                {{ this.run.preliminaryTime | runTime }}
              </v-btn>
          </div>
          <v-simple-table>
            <template v-slot:default>
              <tbody>
                <tr v-for="row in [2, 1, 0]" :key="row">
                  <td v-for="col in [1, 2, 3]" :key="col" style='text-align:center'>
                    <v-btn x-large text v-on:click="addNumber((row * 3) + col)">{{ (row * 3) + col }}</v-btn>
                  </td>
                </tr>
                <tr>
                  <td style='text-align:center' >
                    <v-btn x-large text v-if="stopwatch == null" v-on:click="startStopwatch()"><v-icon>mdi-timer</v-icon></v-btn>
                    <v-btn x-large text v-else v-on:click="stopStopwatch()"><v-icon>mdi-stop</v-icon></v-btn>
                  </td>
                  <td style='text-align:center' v-on:click="addNumber(0)"><v-btn x-large text>0</v-btn></td>
                  <td style='text-align:center' v-on:click="backspace()"><v-btn x-large text><v-icon>mdi-backspace</v-icon></v-btn></td>
                </tr>
              </tbody>
            </template>
          </v-simple-table>
          <v-checkbox :label="$t('runs.disqualification')" v-model="disqualification" hide-details></v-checkbox>
          <v-textarea rows="1" :label="$t('application.remarks')" v-model="remarks"/>
          <div class='d-flex justify-space-around'>
            <span v-if="run.disqualification" class='headline font-weight-black'>{{ $t('runs.disqualification') }}</span>
            <span v-else-if="run.time" class='headline font-weight-black'>{{run.time | runTime}} + {{ run.additionalTime | seconds }} s = {{ run.totalTime | runTime }} </span>
          </div>
        </div>
    </div>
</template>

<script>
  import {
    VCard,
    VTooltip,
    VForm,
    VTextField,
    VCardActions,
    VCardText,
    VSelect,
    VDataTable,
    VDatePicker,
  } from 'vuetify/lib'
  import fccapi from '../../fccapi.js'

  export default {
    name: 'FCCRefereeApplication',
    data: () => ({
      races: [],
      time: "000000",
      stopwatch: null,
      interval: null,
      disqualification: false,
      remarks: ""
    }),
    props: {
      runs: Array,
      index: Number,
      red: Boolean
    },
    computed: {
      formattedStartDate: function(){
        if(!this.startDate) return "";
        var parts = this.startDate.split('-');
        return parts[2]+"."+parts[1]+"."+parts[0];
      },
      formattedEndDate: function(){
        if(!this.endDate) return "";
        var parts = this.endDate.split('-');
        return parts[2]+"."+parts[1]+"."+parts[0];
      },
      rules: function() {
        return {
          required: value =>  !!value || this.$t('registration.required')
        }
      },
      run: function(){
        return this.runs[this.index];
      },
      colorModifier: function(){
        return this.$vuetify.theme.dark?"darken-4":"lighten-4";
      },
      timerFormatted: function(){
        return this.time.substring(0, 2)+":"+this.time.substring(2, 4)+"."+this.time.substring(4, 6);
      },
      confirmedTimeFormatted: function(){
        var r = new RegExp("\\d{2}:(\\d{2}):((\\d{2})(\\.(\\d{2}))?)", "g");
        var result = r.exec(this.run.time);
        if (result){
          return result[1] + ":" + result[3] + "." + (result[5] != undefined?result[5]:"00");
        }
        else {
          return "00:00.00"
        }
      },
      confirmedTime: function(){
        var r = new RegExp("\\d{2}:(\\d{2}):((\\d{2})(\\.(\\d{2}))?)", "g");
        var result = r.exec(this.run.time);
        if (result){
          return result[1]*60*1000 + result[3] * 1000 + result[5];
        }
      },
      isDirty: function(){
        if(!this.run) return false;
        if(this.disqualification != this.run.disqualification) return true;
        if(this.remarks != this.run.remarks) return true;
        if(this.disqualification) return false;
        if(this.confirmedTimeFormatted != this.timerFormatted) return true;
        return false;
      }
    },
    components: {
        VCard,
        VTooltip,
        VForm,
        VTextField,
        VCardActions,
        VCardText,
        VSelect,
        VDataTable,
        VDatePicker,
    },
    methods: {
      usePreliminary: function() {
        var r = new RegExp("\\d{2}:(\\d{2}):((\\d{2})(\\.(\\d{2}))?)", "g");
        var result = r.exec(this.run.preliminaryTime);
        if (result){
          this.time = result[1]+result[3]+(result[5] != undefined?result[5]:"00");
        }
        else {
          this.time = "000000";
        }
      },
      addNumber: function(number) {
        if(this.stopwatch != null) return;
        this.time = this.time + number;
        this.time = this.time.substring(1);
      },
      backspace: function() {
        if(this.stopwatch != null) return;
        this.time = "0" + this.time;
        this.time = this.time.substring(0, 6);
      },
      pad: function (str, max) {
        str = str.toString();
        return str.length < max ? this.pad("0" + str, max) : str;
      },
      updateStopwatch: function() {
        const diffTime = Math.abs(this.stopwatch - new Date());
        var minutes = Math.floor(diffTime / (1000 * 60))
        var seconds = Math.floor((diffTime / 1000) % 60);
        var hundredths = Math.floor((diffTime / 10) % 100);
        this.time = this.pad(minutes, 2)+this.pad(seconds, 2)+this.pad(hundredths, 2)
      },
      startStopwatch: function(){
        this.stopwatch = new Date();
        this.interval = setInterval(this.updateStopwatch, 200);
      },
      stopStopwatch: function(){
        const s = this.stopwatch;
        this.stopwatch = null;
        clearInterval(this.interval);
        const diffTime = Math.abs(s - new Date());
        var minutes = Math.floor(diffTime / (1000 * 60))
        var seconds = Math.floor((diffTime / 1000) % 60);
        var hundredths = Math.floor((diffTime / 10) % 100);
        this.time = this.pad(minutes, 2)+this.pad(seconds, 2)+this.pad(hundredths, 2)
      },
      clearTime: function() {
        this.disqualification = this.run.disqualification;
        this.remarks = this.run.remarks;
        if(this.disqualification){
          this.time = "000000";
        }
        else{
          var r = new RegExp("\\d{2}:(\\d{2}):((\\d{2})(\\.(\\d{2}))?)", "g");
          var result = r.exec(this.run.time);
          if (result){
            this.time = result[1]+result[3]+(result[5] != undefined?result[5]:"00");
          }
          else {
            this.time = "000000";
          }
        }
      },
      save: function() {
        fccapi.post(`runs/${this.run.id}`, {Remarks: this.remarks, Time: "00:"+this.timerFormatted+"0", Disqualification: this.disqualification}).then(d => {
//          this.snackbar = true;
        })
      }
    },
    mounted() {
      fccapi.competitionGet('races').then((r) => {
          this.races = r.data;
      })
    },
    watch: {
      run: function(){
        this.disqualification = this.run.disqualification;
        this.remarks = this.run.remarks;
        if(this.disqualification){
          this.time = "000000";
        }
        else{
          var r = new RegExp("\\d{2}:(\\d{2}):((\\d{2})(\\.(\\d{2}))?)", "g");
          var result = r.exec(this.run.time);
          if (result){
            this.time = result[1]+result[3]+(result[5] != undefined?result[5]:"00");
          }
          else {
            this.time = "000000";
          }
        }
      }
    },
    filters: {
      runTime: function(t) {
        var r = new RegExp("\\d{2}:(\\d{2}:((\\d{2})(\\.(\\d{2}))?))", "g");
        var result = r.exec(t);
        if (!result) return "";
        return result[1].trimLeft() + (result[5] == undefined?".00":"");
      },
      seconds: function(t) {
        var r = new RegExp("\\d{2}:(\\d{2}):(\\d{2}(\\.\\d{2})?)", "g");
        var result = r.exec(t);
        if (!result) return "";
        return parseInt(result[1]) * 60 + parseFloat(result[2]);
      }
    }
  }
</script>